<template>
    <div id="account-idtype">
      <f7-list form class="form-group">
        <f7-list-input
            input-id     ="idType"
            id           ="idTypeInput"
            name         ="idType"
            class        ="clickable-row use-chevron"

            :label       ="$t('ua-id-type')"
            :placeholder ="$t('ua-id-type')"
            :value       ="updateDetails.idType"
            outline
            floating-label
        >
            <f7-link popover-open=".idtype-dropdown-1" slot="content-start" class="clickable-item"></f7-link>
        </f7-list-input>

        <f7-popover id="dropdownIdType" class="idtype-dropdown-1 dropdown-default dropdown account" :backdrop="true">
          <f7-list>
              <f7-list-item v-for="doc in docTypeList" :key="doc.id" popover-close link="#" @click="selectIdType(doc.id);validateInput({id: 'idType'}); validateNextButton()" class="">
                {{ doc.name }}
              </f7-list-item>
          </f7-list>
        </f7-popover>

    </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      docTypeList: Array
    },
    mounted (){
      this.init();
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('customer', [
          'updateDetails'
      ])
    },
    methods: {
      ...mapActions('customer', [
          'setUpdateIdType',
          'validateInput',
      ]),

      async init(){
          const self    = this;
          const popover = ".account.idtype-dropdown-1";
          const popoverInner = ".account.idtype-dropdown-1 .popover-inner";
          const popoverId = "dropdownIdType";
          const inputId = "idType";
          const inputListId = "#idTypeInput";
          await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
      },

      selectIdType(id) {
        const self            = this;
        const docTypeList     = self.docTypeList;

        Object.keys(docTypeList).forEach(key => {
            if(docTypeList[key].id == id) {
                self.setUpdateIdType({id: docTypeList[key].id, name: docTypeList[key].name});
                return;
            }
        })

      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>